/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Templates/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import ImportAction from './ImportAction/index'
import LocationChooser from './LocationChooser/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
let Content = React.lazy(() => import('./Content/index'))



/** @type {import('Simple/types.js').View} */
export default function Templates({
  children,
  viewPath = "/App/Account/Content/Settings/Content/DocumentTemplates/Templates"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Templates.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Templates.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Templates.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Document templates"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Administer document templates. Add new templates and edit existing ones."
/>
</div>
<div
  data-testid="Templates.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-Zmkxee': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Templates.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pl-2-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal1}`}
>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
<ImportAction
  viewPath={`${viewPath}/ImportAction`}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="Templates.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Zmkxee': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-Zmkxee': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</SuspenseBoundary>
</div>
</div>
</div>
{children}
</React.Fragment>)
}